import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import classes from './columns.css';
import moment from 'moment';

export const rahSyncIcon = (row, isRuleFound) => {

    if (row.SyncState && (row.SyncState === 'Queued' || row.SyncState === 'InProgress')) {
        return (
            <Tooltip disableFocusListener disableTouchListener title={<span className={classes.statusLabel}>Syncing to RAH</span>}>
                <i className="fa fa-sync fa-spin text-muted" style={{ color: '#ccc', padding: '0 5px' }}></i>
            </Tooltip>
        );
    }

    if (row.SyncError || row.SyncState === 'Error') {
        return (
            <Tooltip disableFocusListener disableTouchListener title={<span className={classes.statusLabel}>{row.SyncError}</span>}>
                <i className="fas fa-exclamation-circle" style={{ color: '#ff0000', padding: '0 5px' }}></i>
            </Tooltip>
        );
    }

    if (row.Coding.length && !isRuleFound(row) && row.lockedDetails === 'QC' && row.SyncState === 'Completed') {
        return (
            <Tooltip disableFocusListener disableTouchListener title={<span className={classes.statusLabel}>Posted to RAH</span>}>
                <i className="fas fa-check-circle" style={{ padding: '0 5px' }}></i>
            </Tooltip>
        );
    }
    return null
}

export const isUncoded = (item, isRah) => {
  if (isRah) {
    if (item.MatchId) return false;
    if (!(item.Coding && item.Coding[0]) || item.SyncError) return true;
    return item.Coding && item.Coding[0] && item.Coding[0].CodingType === 'Rule';
  }
  if (!(item.Coding && item.Coding[0])) return true;
  return false;
}

export const isRahBankOrCredit = accountCode => accountCode && ['Bank', 'CreditCard'].includes(accountCode.RAHAccountType);

export const hasMatch = (row, matches) => {
  const isMatches = Array.isArray(matches) && matches.length;
  const isSuggestedMatches = Array.isArray(row.SuggestedMatches) && row.SuggestedMatches.length;
  if(isMatches && isSuggestedMatches) {
    return row.SuggestedMatches.some(suggestedMatchId => {
      const curMatch = matches.find(match => match.MatchId === suggestedMatchId);
      return (curMatch && !curMatch.TransactionId);
    })
  }
  return false;
}

export const isMatchable = (row, matches) => {
  return Boolean(row && hasMatch(row, matches) && ((row.Coding[0] && row.Coding[0].CodingType === 'Rule') || row.Coding.length === 0) && row.MatchId === null);
}

export const isUnappliedRule = row => (row.Coding[0] && row.Coding[0].CodingType === 'Rule') || (row.matchedRule && !row.Coding[0] && !row.locked);

export const groupOption = (row, matches, chartOfAccounts) => {
  const isMatches = Array.isArray(matches) && matches.length;
  const isSuggestedMatches = Array.isArray(row.SuggestedMatches) && row.SuggestedMatches.length;
  const transactionMatches = isMatches && isSuggestedMatches ? row.SuggestedMatches.reduce((totalMatches, matchId) => {
    const curMatch = matches.find(match => match.MatchId === matchId);
    if (!curMatch || (curMatch && curMatch.TransactionId && curMatch.TransactionId !== row.BankDataGUID)) return [...totalMatches];
    const date = moment.utc(curMatch.Date).format('DD MMM YY');
    const txnType = curMatch.TxnType.replace(/([A-Z])/g, ' $1').replace('Check', 'Cheque').trim();
    // const allocateTo = Array.isArray(curMatch.AccountDetails) && curMatch.AccountDetails.length > 0 && curMatch.AccountDetails.map(ad => ad.name).join(', ');

    const match = {
      isMatch: true,
      value: curMatch.MatchId,
      date: curMatch.Date,
      label: `${curMatch.TransactionNumber ? `${curMatch.TransactionNumber}, ` : ''}${curMatch.OtherParty && curMatch.OtherParty !== 'Default Contact' ? (curMatch.OtherParty + ',') : ''} $${Math.abs(curMatch.Amount).toFixed(2)}`,
      toolTip: (
        <div>
          {curMatch.OtherParty !== 'Default Contact' && <div><strong>{txnType === 'Receipt' ? 'Customer' : 'Supplier'}:</strong> {curMatch.OtherParty || ''}</div>}
          <div>
            <strong>{txnType === 'Receipt' ? 'Invoice' : 'Bill'}:</strong> {curMatch.TransactionNumber || ''}
          </div>
          <div>
            <strong>{txnType === 'Receipt' ? 'Invoice date' : 'Bill date'}:</strong> {curMatch.Date ? moment.utc(curMatch.Date).format('DD MMM YY') : ''}
          </div>
          <div><strong>Amount:</strong> ${Math.abs(curMatch.Amount).toFixed(2)}</div>
        </div>
      ),
    };
    return [...totalMatches, match];
  }, [])
  .sort((a, b) => {
    if (a.date < b.date) return -1;
    if (a.date > b.date) return 1;
    return 0;
  }) 
  : [];

  return [
    {
      label: 'Match',
      options: transactionMatches
    },
    {
      label: 'Account',
      options: chartOfAccounts
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/TransactionList/Columns/columnsHelpers.js